import { render } from "./SquareWords.vue?vue&type=template&id=749abaae&scoped=true"
import script from "./SquareWords.vue?vue&type=script&lang=ts"
export * from "./SquareWords.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-749abaae"

export default script